import { ReactNode } from "react";

type ToastProps = {
  body: ReactNode;
  title: ReactNode;
}

const Toast = ({body, title}: ToastProps): JSX.Element => {
  return (
    <div className="flex flex-col m-1w">
      <h1 className="text-subtitle1">{title}</h1>
      <p className="text-body1 text-nowrap">{body}</p>
    </div>
  );
}

export default Toast;